import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';

import CollectionFeesSection from '../sections/CollectionFees';
import CurrenciesSection from '../sections/Currencies';
import FinancialBlockSection from '../sections/FinancialBlock';
import LateInterestSection from '../sections/LateInterest';

const dictPrefix = 'financialPortal.settings';

/**
 * Monedas, bloqueo financiero, intereses por mora y gastos de cobranza. Cada
 * sección es autónoma y hace sus propias llamadas.
 */
export default function GeneralTab() {
  const { t } = useTranslation();

  return (
    <Card className="p-4">
      <p className="fs-16 mb-4">{t(`${dictPrefix}.intro`)}</p>
      <CurrenciesSection />
      <FinancialBlockSection />
      <Row className="mt-5">
        <Col xs={12} lg={6}>
          <LateInterestSection />
        </Col>
        <Col xs={12} lg={6}>
          <CollectionFeesSection />
        </Col>
      </Row>
    </Card>
  );
}
